import React, { useContext } from "react";
import { HotelContext } from "../../context/HotelContext";
import { translate } from "../../utils/Translation";
import { LoadingIndicator } from "../../components/v2/cards";

const RewardsAnalysisTable = ({
  loading,
  analysisRows,
  getRewardLogoSrc,
  mapRewardTypeBadgeClass,
  mapRewardTypeLabel,
  getRewardIconColor,
  linkIcon,
  navigate,
  locationSearch,
  setSelectedReward,
}) => {
  const { lang } = useContext(HotelContext);

  return (
    <div className="rewards-list__card rewards-list__card-large">
      <div className="rewards-list__card-header">
        <h3 className="rewards-list__card-title">{translate("v2_rewards_analysis_title", lang)}</h3>
        <p className="rewards-list__card-subtitle">{translate("v2_rewards_analysis_sub", lang)}</p>
      </div>

      <div className="rewards-list__table">
        <div className="rewards-list__table-header">
          <div className="rewards-list__th rewards-list__th--name">{translate("v2_rewards_analysis_name", lang)}</div>
          <div className="rewards-list__th rewards-list__th--type">{translate("v2_rewards_analysis_type", lang)}</div>
          <div className="rewards-list__th rewards-list__th--claim">{translate("v2_rewards_analysis_obtained", lang)}</div>
          <div className="rewards-list__th rewards-list__th--use">{translate("v2_rewards_analysis_claimed", lang)}</div>
          <div className="rewards-list__th rewards-list__th--more">{translate("v2_rewards_analysis_learn_more", lang)}</div>
        </div>

        <div className="rewards-list__table-body">
          {loading ? (
            <div className="rewards-list__table-loading">
              <LoadingIndicator />
            </div>
          ) : analysisRows.length === 0 ? (
            <div className="rewards-list__table-empty">{translate("v2_no_data", lang)}</div>
          ) : (
            analysisRows.map((row, idx) => (
              <React.Fragment key={row.rwId}>
                <div className="rewards-list__tr">
                  <div className="rewards-list__td rewards-list__td--name">
                    {getRewardLogoSrc(row.rwType) ? (
                      <img className="rewards-list__reward-logo" src={getRewardLogoSrc(row.rwType)} alt="" aria-hidden="true" />
                    ) : (
                      <span
                        className="rewards-list__reward-icon"
                        style={{ backgroundColor: getRewardIconColor(row.name, row.rwType) }}
                        aria-hidden="true"
                      />
                    )}
                    <span className="rewards-list__reward-name">{row.name}</span>
                  </div>

                  <div className="rewards-list__td rewards-list__td--type">
                    <span className={`rewards-list__type-badge ${mapRewardTypeBadgeClass(row.rwType)}`}>
                      {mapRewardTypeLabel(row.rwType)}
                    </span>
                  </div>

                  <div className="rewards-list__td rewards-list__td--claim">{row.claimPct}%</div>
                  <div className="rewards-list__td rewards-list__td--use">{row.usePct}%</div>

                  <div className="rewards-list__td rewards-list__td--more">
                    {row.rwType === "EAU" ? (
                      <button
                        type="button"
                        className="rewards-list__info-btn"
                        onClick={() => navigate(`/hotel/lunishower/v2/rewards-donations${locationSearch}`)}
                        aria-label={translate("v2_rewards_nav_donations", lang)}
                      >
                        <img src={linkIcon} alt="" aria-hidden="true" className="rewards-list__link-icon" />
                      </button>
                    ) : row.rwType === "SLIDER" ? (
                      <button
                        type="button"
                        className="rewards-list__info-btn"
                        onClick={() => navigate(`/hotel/lunishower/v2/rewards-sales${locationSearch}`)}
                        aria-label={translate("v2_rewards_nav_sales", lang)}
                      >
                        <img src={linkIcon} alt="" aria-hidden="true" className="rewards-list__link-icon" />
                      </button>
                    ) : row.rwType === "CODE" ? (
                      <span className="rewards-list__muted">-</span>
                    ) : (
                      <button
                        type="button"
                        className="rewards-list__info-btn"
                        onClick={() => setSelectedReward(row)}
                        aria-label={translate("v2_rewards_learn_more_aria", lang, { name: row.name })}
                      >
                        <img src={linkIcon} alt="" aria-hidden="true" className="rewards-list__link-icon" />
                      </button>
                    )}
                  </div>
                </div>
                {idx < analysisRows.length - 1 && <div className="rewards-list__separator" />}
              </React.Fragment>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default RewardsAnalysisTable;
